import {
  red50, pink50, white, red900, green800, green200,
} from '../../ui/colors';

export default {
  customCss: {
    color: white,
    'background-color': white,
    display: 'block',
    width: '100%',
    height: 'calc(1.5em + .75rem + 4px)',
    padding: '.375rem .75rem',
    'font-size': '1rem',
    'font-weight': '400',
    'line-height': '1.5',
    'background-clip': 'padding-box',
    border: '2px solid #ced4da',
    'border-radius': '.25rem',
  },
  invalidCss: {
    'background-color': white,
    'border-color': "#f44336f6",
    color: "black",
  },
  validCss: {
    'background-color': white,
    color: "black",
    'border-color':'#ced4d9 '
  },
  placeholderCss: {
    'font-style': 'normal',
  },
  focusCss: {
    color: '#495057',
    'background-color': white,
    'border-color': '#ced4d9 ',
    outline: '0',
    'box-shadow': '0 0 0 0.2rem rgba(255,88,16)',
    overflow: 'visible',
    margin: 0,
  },
  fields: {
    ccnumber: {
      selector: '#ccnumber',
      title: 'Card Number',
      placeholder: 'card number',
    },
    ccexp: {
      selector: '#ccexp',
      title: 'Card Expiration',
      placeholder: 'MM/YY',
    },
    cvv: {
      display: 'show',
      selector: '#cvv',
      title: 'CVV Code',
      placeholder: '123',
    },
  },
  currency: 'USD',
  country: 'US',
  variant: 'inline',
};
